import Oxford from "./Oxford";

export default {
    Guideline: Oxford
};
